module.exports = __webpack_public_path__ + "img/1_tommy.7840fcb7.jpg";